module.exports = __webpack_public_path__ + "static/img/1.118d65d5.png";